<template>
    <div class="apprentice-simple-card group-list">
        <design-2021-apprentice-data-table
            class="apprentice-group-table"
            :fields="fields"
            :items="items"
            :hide-columns="hideColumns">
            <template v-slot:options>
                <div class="seasons">
                    <label for="season-select">{{ $t('group.school_year') }}</label>
                    <b-form-select
                        class="apprentice-select group-year-select"
                        id="season-select"
                        v-if="seasons.length"
                        @change="seasonChanged"
                        :value="season"
                        :options="seasons"
                        text-field="season"
                        value-field="id">
                    </b-form-select>
                </div>

                <b-button
                    class="btn-add btn-new-group"
                    v-if="isAdmin || $authUser.isTeacher()"
                    variant="primary"
                    @click="showCreatePage()">
                    {{ $t('group.new_project') }}
                </b-button>

                <b-button
                    class="btn-recycle"
                    v-if="isAdmin"
                    variant="primary"
                    @click="showDeletedProjectsPage()">
                    {{ $t('group.recover_project') }}
                </b-button>
            </template>
            <template v-slot:cell(type_id)="row">
                <i
                    v-b-tooltip="getProjectTypeName(row.item.type_id)"
                    :class="getProjectTypeIcon(row.item.type_id)"></i>
            </template>

            <template v-slot:cell(actions)="row">
                <div class="group-actions">
                    <b-button
                        class="btn-open btn-open-group remove-icon-margin"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('group.open_project')"
                        @click="onShow(row)">
                    </b-button>

                    <b-dropdown
                        class="ellipsis-nav bordered-menu project-nav"
                        variant="primary"
                        right
                        text="right align"
                        no-caret
                        toggle-class="project-context-menu">
                        <template #button-content>
                            <i class="fas fa-fw fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item
                            class="edit-group"
                            @click="showModal(row.item)">
                            <i class="btn-edit"></i>{{ $t('group.edit_project') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="copy-group"
                            v-if="[1, 2, 6, 7].includes(row.item.type_id) && $authUser.isAdmin()"
                            @click="showCopyModal(row.item)">
                            <i class="btn-copy"></i>Project kopiëren
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="btn-add-sub-project"
                            @click="addSubProject(row.item)">
                            <i class="btn-add"></i>{{ $t('group.add_subproject') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="btn-remove-project"
                            @click="onRemove(row.item.group_id)">
                            <i class="btn-remove"></i>{{ $t('group.delete_project_confirmation_title') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>

            <template v-slot:cell(group_name)="row">
                <div
                    :class="row.item.parent_id ? 'sibling' : 'parent'"
                    :style="`padding-left: ${row.item.level * 16}px`">
                    {{ row.item.group_name }}
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-quick-edit-group-modal-component
            ref="edit-group-modal"
            :courses-in="courses"
            :seasons-in="seasonsIn"
            @addGroup="addGroup($event)">
        </design-2021-quick-edit-group-modal-component>
        <design-2021-quick-copy-group-modal-component
            ref="copy-group-modal"
            :seasons-in="seasonsIn"
            @addGroup="addGroup"></design-2021-quick-copy-group-modal-component>
        <design-2021-add-sub-group-modal-component
            ref="addSubGroup"
            @sub-group-added="updateItems">
        </design-2021-add-sub-group-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-component',
    props: {
        groupsIn: Array,
        courses: Array,
        seasonsIn: Array,
        isAdmin: Number,
        currentSeasonId: Number,
    },
    data() {
        return {
            groups: this.groupsIn,
            fields: [
                {
                    key: 'group_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'course_title',
                    label: this.$t('group.course'),
                    sortable: true,
                },
                {
                    key: 'start_end_date',
                    label: this.$t('group.start_end'),
                    sortable: true,
                },
                {
                    key: 'season_year',
                    label: this.$t('group.school_year'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            hideColumns: ['actions', 'start_end_date'],
            seasons: [],
            season: 0,
        };
    },

    mounted() {
        let seasonWithGroups = this.seasonsIn
            .filter((season) => this.groups.findIndex((group) => group.season_id === season.id) !== -1)
            .map((season) => {
                if (season.id !== this.currentSeasonId) {
                    return season;
                }
                let currentSeason = { ...season };
                currentSeason.season = this.$t('group.current_school_year');
                return currentSeason;
            });

        if (seasonWithGroups.length) {
            seasonWithGroups.push({
                id: 0,
                season: this.$t('group.all_projects'),
            });
            this.seasons = seasonWithGroups.reverse();

            const key = 'group-overview-season-' + this.$authUser.id;
            const seasonStored = parseInt(localStorage.getItem(key));
            if (seasonStored && this.seasonsIn.some((season) => season.id === seasonStored)) {
                this.season = seasonStored;
            } else if (this.currentSeasonId && this.seasonsIn.some((season) => season.id === this.currentSeasonId)) {
                this.season = this.currentSeasonId;
            }
        }
    },

    methods: {
        check() {
            window.alert('STOP!');
        },

        updateGroup(newGroup) {
            this.groups = this.groups.map((group) => {
                if (group.id === newGroup.id) {
                    return newGroup;
                } else {
                    return group;
                }
            });
        },
        addGroup(newGroup) {
            this.groups.push(newGroup);
        },

        seasonChanged(value) {
            const key = 'group-overview-season-' + this.$authUser.id;
            localStorage.setItem(key, value);
            this.season = value;
        },

        onShow(group) {
            if (group.item.type_id === 3) {
                window.location.href = this.routes.questRapport(group.item.group_id);
            } else {
                window.location.href = this.routes.groupShow(group.item.group_id);
            }
        },
        showModal(group) {
            this.$refs['edit-group-modal'].show(group);
        },
        showCopyModal(group) {
            this.$refs['copy-group-modal'].show(group);
        },
        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('group.delete_project_confirmation_title'),
                    this.$t('group.delete_project_confirmation_body'),
                )
                .then(() => {
                    this.alert.saving();

                    this.axios
                        .delete(this.routes.groupDelete(id))
                        .then((response) => {
                            this.groups = this.groups.filter((group) => !response.data.includes(group.id));
                            this.alert.success();
                        })
                        .catch((error) => {
                            return this.alert.ajaxError(error);
                        });
                });
        },
        showCreatePage() {
            window.location.href = 'group/create';
        },

        showDeletedProjectsPage() {
            window.location.href = 'group/restore';
        },

        addSubProject(project) {
            this.$refs.addSubGroup.show(project);
        },

        updateItems(parentGroupId, newGroup) {
            const key = this.groups.map((group) => group.id).indexOf(parentGroupId);
            this.groups = this.groups.map((group) => {
                if (group.id === parseInt(parentGroupId)) {
                    group.all_children.push(newGroup);
                }

                return group;
            });
            this.groups.splice(key + 1, 0, newGroup);
        },
        getProjectTypeIcon(type_id) {
            switch (type_id) {
                case 1:
                    return 'fad fa-pencil-paintbrush primary';
                case 2:
                    return 'fad fa-file-certificate primary';
                case 3:
                    return 'fad fa-dice primary';
                case 4:
                    return 'fad fa-books primary';
                case 5:
                    return 'fad fa-dumbell primary';
                case 6:
                    return 'fad fa-backpack primary';
                default:
                    return 'fad fa-books primary';
            }
        },
        getProjectTypeName(type_id) {
            switch (type_id) {
                case 1:
                    return 'Werkstuk';
                case 2:
                    return 'Portfolio';
                case 3:
                    return 'Quest';
                case 4:
                    return 'Magazine';
                case 5:
                    return 'Plus';
                case 6:
                    return 'Stage';
                default:
                    return 'Anders';
            }
        },
    },

    computed: {
        items() {
            let items = [];

            if (this.groups.length) {
                items = this.groups.map((group) => {
                    let seasonYear = '';
                    let courseTitle = '';

                    let seasonIndex = this.seasons.findIndex((season) => season.id === group.season_id);
                    if (seasonIndex >= 0) {
                        seasonYear = this.seasons[seasonIndex].season;
                    }

                    let courseIndex = this.courses.findIndex((course) => course.id === group.course_id);
                    if (courseIndex >= 0) {
                        courseTitle = this.courses[courseIndex].name;
                    }

                    return {
                        group_id: group.id,
                        group_name: group.name,
                        course_id: group.course_id,
                        course_title: courseTitle,
                        start_end_date: `${group.startDate ?? group.start_date} | ${group.endDate ?? group.end_date}`,
                        start_date: group.startDate,
                        start: group.start,
                        end: group.end,
                        end_date: group.endDate,
                        season_id: group.season_id,
                        season_year: seasonYear,
                        parent_id: group.parent_id,
                        level: group.level,
                        type_id: group.type_id,
                    };
                });

                if (this.season !== 0) {
                    items = items.filter((item) => {
                        if (item.season_id === this.season) {
                            return true;
                        }
                    });
                }
            }

            return items;
        },
    },
};
</script>

<style scoped lang="scss">
.apprentice-group-table ::v-deep {
    padding: 0;
}

::v-deep .apprentice-data-table-actions {
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .btn {
        width: 100%;
    }
}

.btn-open-group {
    align-self: center;
}

.seasons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 0;

    label {
        margin-bottom: 0;
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }

    .group-year-select {
        min-width: 160px;
    }
}

.group-actions {
    display: flex;

    .btn {
        font-size: 1.125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }

    ::v-deep button.project-context-menu {
        font-size: $base-font-size !important;
        padding: map-get($grid-gutter-spacing, 'five');

        &,
        &:hover,
        &:not(:disabled):not(.disabled):active,
        &:focus,
        &:focus-visible {
            background-color: var(--primary);
            color: $white !important;
        }
    }
}

.sibling {
    padding-left: 16px !important;

    & + .sibling {
        padding-left: 32px !important;

        & + .sibling {
            padding-left: 48px !important;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .group-list {
        ::v-deep .apprentice-table-header {
            .apprentice-table-filters.apprentice-table-filters {
                max-width: 250px;
                flex: 0 0 auto;
                margin-bottom: 0;
            }
        }
    }

    ::v-deep .apprentice-data-table-actions {
        flex-wrap: wrap;
        row-gap: map-get($grid-gutter-spacing, 'ten');

        .btn {
            width: auto;
            flex: 0 0 auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .group-list {
        ::v-deep .apprentice-table-header {
            flex-wrap: wrap;
            flex-direction: row;
            column-gap: map-get($grid-gutter-spacing, 'fifteen');

            ::v-deep .apprentice-table-filters {
                max-width: 250px;
            }

            .apprentice-data-table-actions {
                flex: 0 0 auto;
            }
        }
    }
}
</style>
